import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function PainPointsSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full py-20 px-4 sm:px-6 lg:px-8 bg-[#0a0a1e]" data-id="element-215">
      <div className="max-w-4xl mx-auto" data-id="element-216">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="flex flex-col items-center" data-id="element-217">
          <motion.h2 variants={itemVariants} className="text-2xl sm:text-3xl md:text-4xl font-bold text-white text-center mb-6 leading-tight" data-id="element-218">
            Hoy mismo alguien está buscando cómo vaciar tu cuenta.
          </motion.h2>

          <motion.p variants={itemVariants} className="text-gray-400 text-center max-w-[620px] text-base sm:text-lg mb-4" data-id="element-219">
            No van a usar violencia. Van a entrar por la puerta que vos dejaste
            abierta sin saberlo.
          </motion.p>

          <motion.p variants={itemVariants} className="text-brand-cyan font-bold text-lg sm:text-xl text-center mb-12" data-id="element-220">
            Nadie te enseñó a protegerte. Hasta ahora.
          </motion.p>

          <div className="w-full flex flex-col gap-4" data-id="element-221">
            <motion.div variants={itemVariants} className="bg-[#101840] border border-red-500/30 rounded-xl p-5 flex items-center gap-4 shadow-[0_0_20px_rgba(239,68,68,0.1),0_0_40px_rgba(239,68,68,0.05)] hover:shadow-[0_0_30px_rgba(239,68,68,0.2),0_0_60px_rgba(239,68,68,0.08)] hover:border-red-500/50 transition-all duration-300" data-id="element-222">
              <span className="text-red-500 text-2xl shrink-0 drop-shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-223">
                ❌
              </span>
              <p className="text-white font-medium text-sm sm:text-base" data-id="element-224">
                Mismo PIN en todas tus cuentas — una sola filtración y caen
                todas
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-[#101840] border border-red-500/30 rounded-xl p-5 flex items-center gap-4 shadow-[0_0_20px_rgba(239,68,68,0.1),0_0_40px_rgba(239,68,68,0.05)] hover:shadow-[0_0_30px_rgba(239,68,68,0.2),0_0_60px_rgba(239,68,68,0.08)] hover:border-red-500/50 transition-all duration-300" data-id="element-225">
              <span className="text-red-500 text-2xl shrink-0 drop-shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-226">
                ❌
              </span>
              <p className="text-white font-medium text-sm sm:text-base" data-id="element-227">
                Home Banking y billeteras con configuración de fábrica — sin
                alertas, sin protección real
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-[#101840] border border-red-500/30 rounded-xl p-5 flex items-center gap-4 shadow-[0_0_20px_rgba(239,68,68,0.1),0_0_40px_rgba(239,68,68,0.05)] hover:shadow-[0_0_30px_rgba(239,68,68,0.2),0_0_60px_rgba(239,68,68,0.08)] hover:border-red-500/50 transition-all duration-300" data-id="element-228">
              <span className="text-red-500 text-2xl shrink-0 drop-shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-229">
                ❌
              </span>
              <p className="text-white font-medium text-sm sm:text-base" data-id="element-230">
                Si te vacían la cuenta mañana, no sabés qué hacer ni a quién
                reclamar
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}